import gtag from 'ga-gtag';
import React, { Component } from 'react';
import ReactPixel from 'react-facebook-pixel';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Form, reduxForm } from 'redux-form';
import { numberFormat } from '../../utils';
import { PaymentTypes } from '../../enums/payment';

// node
import { mdiTrashCanOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { toast } from 'react-toastify';

// utils
import { buildUserDataLayer } from '../../utils/dataLayerUser';

// Components
import Loader from '../../components/Loader';
import LoaderForm from '../../components/Loader/loaderForm';
import Payment from '../../components/Payments';
import SummaryCart from '../../components/SummaryCart';
import Terms from '../../components/Terms';
import * as Style from './style';

// partials
import Delivery from './partials/Delivery';
import Itens from './partials/Itens';
import FileVerification from './partials/FileVerification';

// actions
import { fetchAddresses } from '../../actions/address';
import {
  balconySelected,
  clearCart,
  clearCartSummary,
  clearDeliveryOptions,
  deliverySelected,
  fetchCart,
  fetchDeliveryOptions,
  isSubmitForm,
  numberItens,
  resetShippingContact,
  resetWithdrawal,
  setCupom,
  setSummary,
  updateCart,
} from '../../actions/cart';
import {
  modalRegister,
  modalResendFiles,
  modalShippingContact,
  modalWithdrawal,
} from '../../actions/modals';
import {
  clearDataCard,
  clearHashCard,
  clearPayment,
  clearPayments,
  cleanTwoCards,
  hashCard,
  setPayments,
} from '../../actions/payment';

// services
import {
  applyCupom,
  cartClear,
  finishOrder,
  getToken,
  removeCupom,
  removeToken,
  saveOrderName,
  saveOrderObservationNF,
} from '../../services/cart';
import { validateCreditCard } from '../../services/payment';

// utils
import * as constMessage from '../../utils/constMessage';
import { buildPayloadPaymentTwoCards } from '../../utils';

// Styles
import { Col, Row, TextAlign } from '../../styles/align';
import {
  BtnGroup,
  Button,
  ButtonPrimary,
  ButtonSecondary,
  Input,
  Label,
  Wrapper,
  Checkbox,
  Textarea,
} from '../../styles/forms';
import { TitleContainer, TitlePage } from '../../styles/titles';
import { CardAction, CartStyle, Loading, ModalCard } from './style';

class Cart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: '',
      loading: false,
      nome_pedido: '',
      observacoes: '',
      incluirInformacoes: false,
      beginCheckout: false,
    };
  }

  buildGA4Items = () => {
    const { cart } = this.props;
    if (!cart || !cart.carrinho || !cart.carrinho.itens) return [];
  
    return cart.carrinho.itens.map(function(item) {
      var totalItem = parseFloat(item.vlr_total_item) || 0;
      var qty = parseInt(item.qtd_pedido_item) || 1;
      var unitPrice = qty > 0 ? Math.round((totalItem / qty) * 100) / 100 : totalItem;
  
      return {
        item_id: String(item.produto.pk_produto),
        item_name: item.produto.desc_produto || (item.produto.categoria && item.produto.categoria.desc_categoria) || '',
        item_category: item.produto.desc_categoria || '',
        price: unitPrice,
        quantity: qty,
      };
    });
  };
  
  getCartTotal = () => {
    const { cart } = this.props;
    if (!cart || !cart.resumo) return 0;
    var total = parseFloat(cart.resumo.total) || 0;
    var shipping = parseFloat(cart.resumo.entrega) || 0;
    return Math.round((total - shipping) * 100) / 100;
  };

  componentDidMount() {
    const token = getToken();

    this.props.fetchCart(token).then(result => {
      if (this.props.cart !== undefined) {
        this.onUpdate(this.props.cart);

        const ga4Items = this.buildGA4Items();
        const cartTotal = this.getCartTotal();
        if (ga4Items.length > 0) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push(Object.assign({
            event: 'view_cart',
            ecommerce: {
              currency: 'BRL',
              value: cartTotal,
              items: ga4Items,
            },
          }, buildUserDataLayer()));
        }

        if (this.props.cart.carrinho.pedido.nome_pedido) {
          this.setState({
            nome_pedido: this.props.cart.carrinho.pedido.nome_pedido,
          });
        }
      } else {
        toast.error(constMessage.EMPTY_CART);
        setTimeout(() => {
          window.location.href = '/';
        }, 2000);
      }
    });
    this.props.fetchAddresses()
    this.props.fetchDeliveryOptions(token).then(result => {
      if (
        this.props.deliveryOptions &&
        this.props.deliveryOptions.resumo.length
      ) {
        this.onUpdate({
          resumo: this.props.deliveryOptions.resumo,
          pagamento: this.props.deliveryOptions.pagamento,
        });
      }
    });
  }

  componentDidUpdate(prevProps) {

  }

  onUpdate = ({
    resumo,
    pagamento,
    hash,
    clearPayment,
    clearDelivery,
    cleanTwoCards,
  }) => {
    if (clearPayment) {
      this.props.clearPayment();
      this.props.clearPayments();
    }

    if (pagamento) {
      this.props.setPayments(pagamento);

      var cartKey = 'begin_checkout_' + (this.props.cart && this.props.cart.carrinho
        ? this.props.cart.carrinho.itens.map(function(i) { return i.produto.pk_produto; }).join('_')
        : 'empty');
      if (!sessionStorage.getItem(cartKey)) {
        var ga4Items = this.buildGA4Items();
        var cartTotal = this.getCartTotal();
        if (ga4Items.length > 0) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push(Object.assign({
            event: 'begin_checkout',
            ecommerce: {
              currency: 'BRL',
              value: cartTotal,
              items: ga4Items,
            },
          }, buildUserDataLayer()));
          sessionStorage.setItem(cartKey, 'true');
        }
      }
    }

    if (resumo) {
      this.props.setSummary(resumo);
    }

    if (hash) {
      this.props.hashCard(hash);
    }

    if (cleanTwoCards) {
      this.props.cleanTwoCards();
    }

    if (clearDelivery) {
      this.props.balconySelected({
        balconySelected: false,
        balconyType: false,
      });
      this.props.deliverySelected({
        deliverySelected: false,
        deliveryType: false,
      });
      this.props.clearDeliveryOptions();
    }
  };

  componentWillUnmount() {
    this.props.clearCart();
    this.props.clearDeliveryOptions();
    this.props.clearPayment();
    this.props.clearCartSummary();
    this.props.clearPayments();
    this.props.resetShippingContact();
    this.props.resetWithdrawal();
    this.props.isSubmitForm(false);
    this.props.clearHashCard();
    this.onUpdate({ clearDelivery: true });
  }

  renderOrderName = () => {
    return (
      <CardAction>
        <span>Nome do Pedido</span>
        <Input
          onChange={e => this.setState({ nome_pedido: e.target.value })}
          value={this.state.nome_pedido}
        />
        <BtnGroup>
          <ButtonPrimary onClick={this.handleSaveOrderName}>
            Salvar
          </ButtonPrimary>
        </BtnGroup>
      </CardAction>
    );
  };

  renderObservation = () => {
    return (
      <CardAction>
        <Wrapper>
          <Checkbox
            id={'informacoesNF'}
            onChange={e => this.handleCheckboxChange(e)}
            checked={this.state.incluirInformacoes}
          />
          <span></span>
          <Label htmlFor="informacoesNF">
            Deseja incluir observações na sua Nota Fiscal?
          </Label>
          <Style.AvisoNotaFiscal>
                  <strong>Atenção:</strong> A nota fiscal será emitida com os dados
                  do cadastro da compra, não é possível a emissão com dados
                  diferentes. <p>Em caso de CNPJ, atente-se à situação da sua Inscrição
                  Estadual (IE) para não haver atrasos na entrega por pendências
                  cadastrais.</p>
          </Style.AvisoNotaFiscal>
          <ModalCard>
            {this.state.incluirInformacoes && (
              <Wrapper>
                <Textarea
                  id="observacoes"
                  name="observacoes"
                  value={this.state.observacoes}
                  onChange={this.handleObservacoesChange}
                  placeholder="Insira observações não fiscais do seu pedido (ex.: nome do projeto, patrocínios)"
                ></Textarea>
                <BtnGroup>
                  <ButtonPrimary onClick={this.handleSaveObservationNF}>
                    Salvar
                  </ButtonPrimary>
                </BtnGroup>
              </Wrapper>
            )}
          </ModalCard>
        </Wrapper>
      </CardAction>
    );
  };

  renderCupom = () => {
    const { cupom, cart } = this.props;

    return (
      <CardAction>
        <Col>
          <Row>
            <span>Cupom de Desconto</span>
            <Input
              onChange={e => this.props.setCupom({ cupom: e.target.value })}
              value={cupom}
            />
            <BtnGroup>
              <ButtonPrimary type="button" onClick={this.handleApplyCupom}>
                Aplicar
              </ButtonPrimary>
              {cart.carrinho.cupom ? (
                <ButtonSecondary type="button" onClick={this.handleRemoveCupom}>
                  Limpar Cupom
                </ButtonSecondary>
              ) : (
                ''
              )}
            </BtnGroup>
          </Row>
          {cart.carrinho.cupom ? (
            <Row>
              <p>{cart.carrinho.cupom.mensagem}</p>
            </Row>
          ) : (
            ''
          )}
        </Col>
      </CardAction>
    );
  };

  handleApplyCupom = async () => {
    const response = await applyCupom(this.props.cupom);
    if (response.status === 200) {
      this.props.updateCart(response.data);

      this.onUpdate({
        resumo: response.data.data.resumo,
        pagamento: response.data.data.pagamento,
        clearPayment: true,
      });
      toast.success(response.data.message);
    } else {
      toast.error(response.errors.message || constMessage.APPLY_CUPOM_ERROR);
    }
  };

  handleRemoveCupom = async () => {
    const response = await removeCupom();
    if (response.status === 200) {
      this.props.setCupom({ cupom: '' });
      this.props.updateCart(response.data);

      this.onUpdate({
        resumo: response.data.data.resumo,
        pagamento: response.data.data.pagamento,
        clearPayment: true,
      });
      toast.success(response.data.message);
    } else {
      toast.error(constMessage.CONNECTION_ERROR);
    }
  };

  handleSaveOrderName = async () => {
    const response = await saveOrderName(this.state.nome_pedido);
    if (response.status === 200) {
      toast.success(constMessage.ORDER_NAME_SUCCESS);
    } else {
      toast.error(constMessage.ORDER_NAME_ERROR);
    }
  };

  handleSaveObservationNF = async () => {
    const response = await saveOrderObservationNF(this.state.observacoes);
    if (response.status === 200) {
      toast.success(constMessage.ORDER_OBSNF_SUCCESS);
    } else {
      toast.error(constMessage.ORDER_OBSNF_ERROR);
    }
  };

  onRedirect = url => {
    this.props.history.push(url);
  };

  handleSubmit = async () => {
    let dataPayment = {};
    const {
      multiplePayments,
      payment,
      userLogged,
      clearDataCard,
      twoCards,
    } = this.props;

    const ga4Items = this.buildGA4Items();
    const cartTotal = this.getCartTotal();

    var shippingValue = this.props.cart && this.props.cart.resumo
    ? parseFloat(numberFormat(this.props.cart.resumo.entrega))
    : 0;
    var shippingTier = this.props.typeDelivery === '1' ? 'entrega' : 'balcao';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({
      event: 'add_shipping_info',
      ecommerce: {
        currency: 'BRL',
        value: cartTotal,
        shipping_tier: shippingTier,
        items: ga4Items,
      },
    }, buildUserDataLayer()));

    if (!userLogged.cpf_cnpj_usuario) {
      toast.warn(constMessage.FORM_SUBMIT_BLANK);
      this.props.modalRegister();
      return false;
    }

    if (this.props.typeDelivery === '1') {
      if (
        this.props.deliverySelected === false ||
        this.props.deliveryType === false
      ) {
        toast.warn(constMessage.CHOOSE_DELIVERY);
        return false;
      }
    } else {
      if (
        this.props.balconySelected === false ||
        this.props.balconyType === false
      ) {
        toast.warn(constMessage.CHOOSE_DELIVERY);
        return false;
      }
      if (!this.props.withdrawalDone) {
        this.props.modalWithdrawal();
        this.props.isSubmitForm(true);
        return false;
      }
    }

    if (payment.tipo_pagamento === '') {
      toast.warn(constMessage.CHOOSE_PAYMENT);
      return false;
    }

    switch (payment.tipo_pagamento) {
      case '1':
        if (!payment.pagamento) {
          toast.warn(constMessage.SELECT_DEPOSIT);
          return false;
        }
        dataPayment = {
          tipo_pagamento: payment.tipo_pagamento,
          pagamento: payment.pagamento,
        };
        break;
      case PaymentTypes.CREDIT_CARD:
        const validateResult = validateCreditCard(payment);
        if (validateResult.status !== 'success') {
          toast[validateResult.status](validateResult.message);
          clearDataCard();
          return false;
        }
        dataPayment = {
          ...payment,
          pagamento: payment.dependency, // precisa verificar onde tem que setar isso no redux
        };
        break;
      case '4':
        dataPayment = {
          tipo_pagamento: payment.tipo_pagamento,
          pagamento: '13',
        };
        break;
      case '6':
        dataPayment = {
          tipo_pagamento: payment.tipo_pagamento,
          pagamento: '22', // precisa verificar onde tem que setar isso no redux
        };
        break;
      case '10':
        dataPayment = {
          tipo_pagamento: payment.tipo_pagamento,
          pagamento: '32', // precisa verificar onde tem que setar isso no redux
        };
        break;
      case '13':
        dataPayment = {
          tipo_pagamento: payment.tipo_pagamento,
          pagamento: '44', // precisa verificar onde tem que setar isso no redux
        };
        break;
      // no pagamento, só add as infos que o back vai precisar
      // Mudar pra um numero inteiro (verificar qual numero colocar, Cleber falou)
      case 'twoCards':
        const twoCardsValidData =
          validateCreditCard(twoCards.firstCard) &&
          validateCreditCard(twoCards.secondCard);
        if (twoCardsValidData.status !== 'success') {
          toast[twoCardsValidData.status](twoCardsValidData.message);
          return false;
        }
        dataPayment = {
          // tipo_pagamento: payment.tipo_pagamento,
          // verificar qual numero colocar (talvez vai ser necessário criar tabela no banco, Cleber falou)
          tipo_pagamento: 3,
          ...buildPayloadPaymentTwoCards({
            primeiroCartao: twoCards.firstCard,
            segundoCartao: twoCards.secondCard,
          }),
        };
        break;
      default:
        toast.warn(constMessage.CHOOSE_PAYMENT);
        break;
    }

    if (multiplePayments) {
      dataPayment = {
        ...dataPayment,
        tipo_pagamento_credito: '4',
        pagamento_credito: '13',
      };
    }

    let retorna = false;
    this.props.cart.carrinho.itens.forEach(item => {
      if (item.pedidoItemArquivo === undefined) {
        retorna = true;
      }
    });
    if (retorna === true) {
      this.props.modalResendFiles();
      return false;
    }

    if (!this.props.checkedTerms) {
      // As 2 caixas de termos de aceite devem estar marcadas
      toast.warn(constMessage.TERMS_OF_USE);
      return false;
    }

    if (!this.props.shippingContactDone) {
      this.props.modalShippingContact();
      this.props.isSubmitForm(true);
      return false;
    }

    const paymentTypeMap = {
      '1': 'deposit',
      '3': 'credit_card',
      '4': 'pix',
      '6': 'shopline',
      '10': 'bknbank',
      '13': 'pix',
      'twoCards': 'two_credit_cards',
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({
      event: 'add_payment_info',
      ecommerce: {
        currency: 'BRL',
        value: cartTotal,
        payment_type: paymentTypeMap[payment.tipo_pagamento] || String(payment.tipo_pagamento),
        items: ga4Items,
      },
    }, buildUserDataLayer()));

    dataPayment = {
      ...dataPayment,
      observacoes: this.state.observacoes,
    };

    const response = await finishOrder(dataPayment);

    if (response.status === 200) {
      toast.success(constMessage.FINISH_ORDER_SUCCESS);

    // --- GA4 Purchase ---
    const transactionId = String(response.data.data.pk_pedido);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({
      event: 'purchase',
      ecommerce: {
        transaction_id: transactionId,
        affiliation: 'Fábrica do Livro',
        value: cartTotal,
        shipping: parseFloat(this.props.cart.resumo.entrega) || 0,
        tax: 0,
        currency: 'BRL',
        coupon: this.props.cupom || '',
        items: ga4Items,
      },
    }, buildUserDataLayer()));

    // --- Google Ads (MANTER como está) ---
    gtag('event', 'conversion', {
      send_to: 'AW-705761160/TN30CM6eirEBEIifxNAC',
      value: this.props.cart.resumo.total,
      currency: 'BRL',
      transaction_id: response.data.data.pk_pedido,
    });

    // --- Facebook Pixel (CORRIGIDO — products estava vazio) ---
    const fbOptions = { autoConfig: true, debug: false };
    ReactPixel.init('400964964142464', fbOptions);
    ReactPixel.pageView();

    const productsData = this.props.cart.carrinho.itens.map(item => ({
      id: item.produto.pk_produto,
      quantity: item.qtd_pedido_item,
      item_price: parseFloat(item.vlr_total_item),
    }));

    ReactPixel.track('Purchase', {
      value: this.props.cart.resumo.total,
      currency: 'BRL',
      contents: productsData,
      content_type: 'product',
    });

    if (
      payment.tipo_pagamento === '3' ||
      payment.tipo_pagamento === 'twoCards' ||
      payment.tipo_pagamento === '11' || payment.tipo_pagamento === '12' || payment.tipo_pagamento === '4'
    ) {
      var paymentConfKey = 'payment_confirmed_' + transactionId;
      if (!sessionStorage.getItem(paymentConfKey)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(Object.assign({
          event: 'payment_confirmed_instant',
          ecommerce: {
            transaction_id: transactionId,
            value: cartTotal,
            currency: 'BRL',
            payment_type: 'credit_card',
            items: ga4Items,
          },
        }, buildUserDataLayer()));
        sessionStorage.setItem(paymentConfKey, 'true');
      }
    }

    this.props.history.push(`/sucesso/${response.data.data.pk_pedido}`);
      removeToken();
      this.props.numberItens(0);
    } else {
      toast.error(constMessage.CONNECTION_ERROR);
    }
  };

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  };

  // Limpar carrinho
  handleClearCart = () => {
    this.toggleLoading();
    const token = getToken();
    cartClear().then(response => {
      if (response.status === 200) {
        this.props.fetchCart(token);
        this.toggleLoading();
        toast.success(constMessage.REMOVE_ITEMS_CART);
        window.location.href = '/';
      } else {
        toast.error('Erro ao limpar carrinho');
      }
    });
  };

  handleCheckboxChange = event => {
    const isChecked = event.target.checked;
    this.setState({
      incluirInformacoes: isChecked,
      observacoes: isChecked ? this.state.observacoes : '',
    });
  };

  handleObservacoesChange = event => {
    this.setState({ observacoes: event.target.value });
  };

  render() {
    const { cart, handleSubmit, submitting } = this.props;

    if (submitting || !cart) {
      return (
        <CartStyle>
          <Col>
            <Loader />
          </Col>
        </CartStyle>
      );
    }

    if (!this.props.cart.carrinho.itens) {
      return (
        <CartStyle>
          <TextAlign>Você não possui itens adicionados no carrinho!</TextAlign>
        </CartStyle>
      );
    }

    return (
      <CartStyle>
        {this.state.loading ? (
          <Loading>
            <Loader />
          </Loading>
        ) : (
          ''
        )}
        <Col>
          <TitleContainer>
            <TitlePage>
              <span>Meu Carrinho</span>
            </TitlePage>
            <span>
              <Button onClick={this.handleClearCart}>
                <Icon
                  path={mdiTrashCanOutline}
                  text={'LimparCarrinho'}
                  size={0.8}
                />
                Limpar Carrinho
              </Button>
            </span>
          </TitleContainer>

          <Itens
            onRedirect={this.onRedirect}
            onUpdate={this.onUpdate}
            toggleLoading={this.toggleLoading}
          />
          <FileVerification />

          <Row>
            <Delivery
              toggleLoading={this.toggleLoading}
              onUpdate={this.onUpdate}
            />
            <Col>
              <SummaryCart />
              {this.renderCupom()}
              {this.renderOrderName()}
              {this.renderObservation()}
            </Col>
          </Row>
          <Payment />
          <Terms />
          <Form onSubmit={handleSubmit(this.handleSubmit)}>
            <BtnGroup>
              <Link to={'/'}>
                <ButtonSecondary>Continuar Comprando</ButtonSecondary>
              </Link>
              <ButtonPrimary type={'submit'} disabled={submitting} secondary>
                Finalizar Compra{submitting ? <LoaderForm /> : ''}
              </ButtonPrimary>
            </BtnGroup>
          </Form>
        </Col>
      </CartStyle>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart.data,
    deliveryOptions: state.cart.deliveryOptions,
    payment: state.payment.payment,
    typeDelivery: state.cart.typeDelivery,
    deliverySelected: state.cart.deliverySelected,
    balconySelected: state.cart.balconySelected,
    multiplePayments: state.payment.multiplePayments,
    withdrawalDone: state.cart.withdrawalDone,
    shippingContactDone: state.cart.shippingContactDone,
    balconyType: state.cart.balconyType,
    deliveryType: state.cart.deliveryType,
    cupom: state.cart.cupom,
    userLogged: state.user.user,
    checkedTerms: state.cart.produtosChecked && state.cart.envioArquivosChecked,
    twoCards: state.payment.twoCards,
  };
};

Cart = reduxForm({
  form: 'cart',
})(Cart);

Cart = connect(mapStateToProps, {
  fetchCart,
  modalWithdrawal,
  fetchAddresses,
  fetchDeliveryOptions,
  clearCart,
  clearDeliveryOptions,
  clearPayment,
  clearDataCard,
  setPayments,
  hashCard,
  setSummary,
  numberItens,
  clearCartSummary,
  clearPayments,
  cleanTwoCards,
  modalShippingContact,
  modalRegister,
  resetShippingContact,
  resetWithdrawal,
  isSubmitForm,
  clearHashCard,
  deliverySelected,
  balconySelected,
  setCupom,
  updateCart,
  modalResendFiles,
})(Cart);

export default Cart;
